import store from '../store'

export function makeOutboundCall(name,number) {

    console.log(name,number)

    let agent = new connect.Agent();

    let callNumber = connect.Endpoint.byPhoneNumber(number);
    
    agent.connect(callNumber, {
        success: () => {
            console.log("sent outbound call");
            store.dispatch('call/updateOnOutboundFlag',true)
        },
        failure: (err) => {
        console.log("Failed to send outbound call");
        alert("Cannot make Outbound Call to this number")
        var payload = {};
        payload.action = "UNABLE_TO_MAKE_OUTBOUND_CALL";
        parent.postMessage(payload,'*');
        console.log(err);
        }
    });
}

export function onAcceptCall() {

    let agent = new connect.Agent();

    let contact = agent.getContacts(connect.ContactType.VOICE)[0];

    contact.accept({
        success: function() { 
            console.log("Accepted")
        },
        failure: function(err) { 
            console.log(err)
        }
     });
  
}

export function onDeclineCall() {

    let agent = new connect.Agent();

    let contact = agent.getContacts(connect.ContactType.VOICE)[0];

    contact.reject({
        success: function() { 
            console.log("rejected")
        },
        failure: function(err) { 
            console.log(err)
        }
     });
  
}

export function onEndIntialCall() {

    let agent = new connect.Agent();

    let contact = agent.getContacts(connect.ContactType.VOICE)[0];

    console.log("THIS IS SNAPSHOT DURING THE CALL",contact.toSnapshot())

    var thirdPartyConn = contact.getSingleActiveThirdPartyConnection();

    console.log("thirdpartyConnection data",thirdPartyConn)
    console.log("thirdpartyConnection snapshot",thirdPartyConn)


    let connection = contact.getInitialConnection(connect.ContactType.VOICE);

    connection.destroy({
        success: function() { 
            console.log("Initial call ended")
        },
        failure: function(err) { 
            console.log(err)
        }
     });
  
}

export function onEndThirdPartyCall() {

    let agent = new connect.Agent();

    let contact = agent.getContacts(connect.ContactType.VOICE)[0];

    let connection = contact.getSingleActiveThirdPartyConnection(connect.ContactType.VOICE);

    connection.destroy({
        success: function() { 
            console.log("thirdparty call ended")
        },
        failure: function(err) { 
            console.log(err)
        }
     });
  
}

export function onClearContacts() {

    let agent = new connect.Agent();

    let contact = agent.getContacts(connect.ContactType.VOICE)[0];

    contact.clear()
  
}

export function onholdToggleInitialCall() {

    let agent = new connect.Agent();

    let contact = agent.getContacts(connect.ContactType.VOICE)[0];

    let connection = contact.getInitialConnection();

    if(connection.isOnHold()) {

        connection.resume({
            success: function() { 
                console.log("intial conn resumed")
            },
            failure: function(err) { 
                console.log(err)
            }
        });

    } else {

        connection.hold({
            success: function() { 
                console.log("intial conn hold")
                var messageData = {};
                messageData.action = "FRESHCHAT_HOLD";
                messageData.conversationId = store.getters.freshchat_conversation_id;
                messageData.channelId = store.getters.freshchat_channel_id;
                messageData.contactId = store.getters.contact_id;
                messageData.callType = store.getters.call_state;
                messageData.callerNumber = store.getters.caller_number;
                messageData.userId = store.getters.freshchat_user_id;
                parent.postMessage(messageData,'*');
            },
            failure: function(err) { 
                console.log(err)
            }
        });
    }
  
}


export function onresumeToggleInitialCall() {

    let agent = new connect.Agent();

    let contact = agent.getContacts(connect.ContactType.VOICE)[0];

    let connection = contact.getInitialConnection();

    if(connection.isOnHold()) {

        connection.resume({
            success: function() { 
                console.log("intial conn resumed")
            },
            failure: function(err) { 
                console.log(err)
            }
        });

    } else {

        connection.hold({
            success: function() { 
                console.log("intial conn hold")
                var messageData = {};
                messageData.action = "FRESHCHAT_HOLD";
                messageData.conversationId = store.getters.freshchat_conversation_id;
                messageData.channelId = store.getters.freshchat_channel_id;
                messageData.contactId = store.getters.contact_id;
                messageData.callType = store.getters.call_state;
                messageData.callerNumber = store.getters.caller_number;
                messageData.userId = store.getters.freshchat_user_id;
                parent.postMessage(messageData,'*');
            },
            failure: function(err) { 
                console.log(err)
            }
        });
    }
  
}

export function onholdToggleThirdPartyCall() {

    let agent = new connect.Agent();

    let contact = agent.getContacts(connect.ContactType.VOICE)[0];

    let connection = contact.getSingleActiveThirdPartyConnection();

    if(connection.isOnHold()) {

        connection.resume({
            success: function() { 
                console.log("third party conn resumed")
                store.dispatch("call/updateThirdPartyHoldStatus",false)
            },
            failure: function(err) { 
                console.log(err)
            }
        });

    } else {

        connection.hold({
            success: function() { 
                console.log("third party conn hold")
                store.dispatch("call/updateThirdPartyHoldStatus",true)

            },
            failure: function(err) { 
                console.log(err)
            }
        });
    }
  
}

export function onMuteToggle(status) {
    console.log("on mute status",status)
    
    let agent = new connect.Agent();
    console.log("ON MUTE TOGGLER",agent)

    if(status) {
        agent.unmute()

    } else {
        agent.mute()
    }
  
}

// conference call 

export function onAddConference(type,number) {

    console.log(type,number)
    
    let agent = new connect.Agent();

    let contact = agent.getContacts()[0];

    let thirdParty;

    if(type == 'number') {
        thirdParty = connect.Endpoint.byPhoneNumber(number);
    } else {
        thirdParty = number
    }

    return new Promise((resolve,reject)=>{
        contact.addConnection(thirdParty,{
            success : () => {
      
                console.log("conference call")
                var messageData = {};
                if(store.getters.outboundCall == false){
                messageData.action = "FRESHCHAT_CONFERENCE_CALL";
                messageData.callDirection = "INCOMING_CALL"
                messageData.amazonConnectChannelId = store.getters.freshchat_channel_id;               
                messageData.conversationId = store.getters.freshchat_conversation_id;
                messageData.channelId = store.getters.freshchat_channel_id;
                messageData.contactId = store.getters.contact_id;
                messageData.callType = store.getters.call_state;
                messageData.callerNumber = store.getters.caller_number;
                messageData.userId = store.getters.freshchat_user_id;
                messageData.freshchatAgentId = store.getters.freshchat_agent_id;
                parent.postMessage(messageData,'*');
                }else{
                    messageData.action = "FRESHCHAT_CONFERENCE_CALL";
                    messageData.callDirection = "OUTGOING_CALL"
                    messageData.amazonConnectChannelId = store.getters.freshchat_channel_id;               
                    messageData.conversationId = store.getters.freshchat_conversation_id;
                    messageData.channelId = store.getters.freshchat_channel_id;
                    messageData.contactId = store.getters.contact_id;
                    messageData.callType = store.getters.call_state;
                    messageData.callerNumber = store.getters.caller_number;
                    messageData.userId = store.getters.freshchat_user_id;
                    messageData.freshchatAgentId = store.getters.freshchat_agent_id;
                    parent.postMessage(messageData,'*');

                }
                resolve("success")
            },
            failure : (err) => {
                resolve("fail")
                console.log(err)
                let postData = {};
                postData.action = "SHOW_NOTIFICATION";
                postData.type = "INAVLID_PHONE_NUMBER";
                parent.postMessage(postData,"*" );
                store.dispatch("call/setCallType", "normal");
                store.dispatch("actions/callSubNavigation", "call");
            }
        })
    })  
}

export function onSwapCall() {

    let agent = new connect.Agent();

    let contact = agent.getContacts(connect.ContactType.VOICE)[0];

    contact.toggleActiveConnections({
        success: () => { 
            console.log("call swapped")
        },
        failure: (err) => { 
            console.log("call swapp fail")
         }
     });
}

export function onJoinCall() {

    let agent = new connect.Agent();

    let contact = agent.getContacts(connect.ContactType.VOICE)[0];

    contact.conferenceConnections({
        success: () => { 
            console.log("call joined")
            var messageData = {};

            //Call Merged Payload for Freshchat 
            if(store.getters.outboundCall == false){
                messageData.action = "FRESHCHAT_MERGED_CALL";
                messageData.callDirection = "INCOMING_CALL"
                messageData.amazonConnectChannelId = store.getters.freshchat_channel_id;              
                messageData.conversationId = store.getters.freshchat_conversation_id;
                messageData.channelId = store.getters.freshchat_channel_id;
                messageData.contactId = store.getters.contact_id;
                messageData.callType = store.getters.call_state;
                messageData.callerNumber = store.getters.caller_number;
                messageData.userId = store.getters.freshchat_user_id;
                messageData.freshchatAgentId = store.getters.freshchat_agent_id;
                parent.postMessage(messageData,'*');
                }else{
                    messageData.action = "FRESHCHAT_MERGED_CALL";
                    messageData.callDirection = "OUTGOING_CALL"
                    messageData.amazonConnectChannelId = store.getters.freshchat_channel_id;
                    messageData.conversationId = store.getters.freshchat_conversation_id;
                    messageData.channelId = store.getters.freshchat_channel_id;
                    messageData.contactId = store.getters.contact_id;
                    messageData.callType = store.getters.call_state;
                    messageData.callerNumber = store.getters.caller_number;
                    messageData.userId = store.getters.freshchat_user_id;
                    messageData.freshchatAgentId = store.getters.freshchat_agent_id;
                    parent.postMessage(messageData,'*');

                }
        },
        failure: (err) => { 
            console.log("call join fail")
         }
     });
}

export function notifyIssue(){
    let agent = new connect.Agent()
    let contact = agent.getContacts(connect.ContactType.VOICE)[0];
    contact.notifyIssue(issueCode, description, {
        success: function() { 
            console.log("ISSUE IS NOTIFIED",issueCode,description)
        },
        failure: function(err) { 
            console.log("ISSUE NOTIFICATION ERROR",err)


         }
     });
}

export function onHoldAll() {

    let agent = new connect.Agent();

    let contact = agent.getContacts(connect.ContactType.VOICE)[0];

    let connection = contact.getInitialConnection();
    let thirdPartyConnection = contact.getSingleActiveThirdPartyConnection();

    if(!connection.isOnHold()) {

        connection.hold({
            success: function() { 
                console.log("intial conn hold")
                if(!thirdPartyConnection.isOnHold()) {

                    thirdPartyConnection.hold({
                        success: function() { 
                            console.log("third party conn hold")
                        },
                        failure: function(err) { 
                            console.log("on hold all third party",err)
                        }
                    });
            
                }

                if(thirdPartyConnection.isOnHold()){
                    console.log("Third party is already on hold")
                }
            },
            failure: function(err) { 
                console.log(err)
            }
        });
    }
    if(connection.isOnHold()){
        if(!thirdPartyConnection.isOnHold()){
            thirdPartyConnection.hold({
                success: function() { 
                    console.log("third party conn hold")
                },
                failure: function(err) { 
                    console.log("on hold all third party",err)
                }
            });

        }

        if(thirdPartyConnection.isOnHold()){
            console.log("Third party is already on hold")


        }
    }

    // if(!thirdPartyConnection.isOnHold()) {

    //     thirdPartyConnection.hold({
    //         success: function() { 
    //             console.log("third party conn hold")
    //         },
    //         failure: function(err) { 
    //             console.log("on hold all third party",err)
    //         }
    //     });

    // }
}

export function onResumeAll() {


    onJoinCall()

    // let agent = new connect.Agent();

    // let contact = agent.getContacts(connect.ContactType.VOICE)[0];

    // let connection = contact.getInitialConnection();
    // let thirdPartyConnection = contact.getSingleActiveThirdPartyConnection();


    // if(connection.isOnHold() && thirdPartyConnection.isOnHold()) {

    //     connection.resume({
    //         success: function() { 
    //             console.log("Initial party conn resumed")
                
    //                 thirdPartyConnection.resume({
    //                     success: function() { 
    //                         console.log("intial conn resumed")
                           
    //                     },
    //                     failure: function(err) { 
    //                         console.log(err)
    //                     }
    //                 });
                
    //         },
    //         failure: function(err) { 
    //             console.log(err)
    //             thirdPartyConnection.resume({
    //                 success: function() { 
    //                     console.log("intial conn resumed")
                       
    //                 },
    //                 failure: function(err) { 
    //                     console.log(err)
    //                 }
    //             });
    //         }
    //     });

    // }else if(!connection.isOnHold() && thirdPartyConnection.isOnHold()){
    //     thirdPartyConnection.resume({
    //         success: function() { 
    //             console.log("intial conn resumed")
               
    //         },
    //         failure: function(err) { 
    //             console.log(err)
    //         }
    //     });

    // }else if(connection.isOnHold() && !thirdPartyConnection.isOnHold()){

    //     connection.resume({
    //         success: function() { 
    //             console.log("Initial party conn resumed")
    //         },
    //         failure: function(err) { 
    //             console.log(err)
    //         }
    //     });

    // }

  



    // if(!thirdPartyConnection.isOnHold()) {

    //     console.log("Third Party connection is already in resumed state")
    //     if(connection.isOnHold()) {

    //         connection.resume({
    //             success: function() { 
    //                 console.log("Initial connection is resumed")
    //             },
    //             failure: function(err) { 
    //                 console.log(err)
    //             }
    //         });
    
    //     }

    //     if(!connection.isOnHold()){
    //         console.log("Initial Connection is already in resumed state")
    //     }

    // }

  

    // if(thirdPartyConnection.isOnHold()) {

    //     thirdPartyConnection.resume({
    //         success: function() { 
    //             console.log("third party conn resumed")
    //         },
    //         failure: function(err) { 
    //             console.log(err)
    //         }
    //     });

    // }
}

export function onLeaveCall() {

    let agent = new connect.Agent();

    let contact = agent.getContacts(connect.ContactType.VOICE)[0];

    contact.getAgentConnection().destroy();
}

export function logoutAgent(){
 var instance = store.getters.connect_instance;
 var domain = new URL(instance);
 var logout_domain = domain.hostname
fetch(`https://${logout_domain}/connect/logout`, { credentials: 'include', mode: 'no-cors'})
  .then(() => {
    console.log("LOGOUT EVENT TRIGGERED SUCCESSFULLY")
    const eventBus = connect.core.getEventBus();
    eventBus.trigger(connect.EventType.TERMINATE);
    store.dispatch("common/routePage","login")
    var passData = {};
    passData.action = "AGENT_DISCONNECTED"
    parent.postMessage(passData,"*")
  });
}